import config from "config/config";

const { baseUrl, clientUrl } = config;
/* *********************

********************** */

export default function resetPassword(token, password) {
  const endpoint = `${baseUrl}/v1/auth/reset-password?token=${token}`;
  const options = {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": `${clientUrl || ""}`,
      "Access-Control-Allow-Credentials": true,
    },
    body: JSON.stringify({ password }),
  };
  return fetch(endpoint, options)
    .then((response) => {
      if (response.status >= 200 && response.status <= 299) {
        return response;
      }
      return response;
    })
    .catch((e) => {
      console.log("error", e);
    });
}
